import { Common } from '~/models/common';
import { Domains } from '~/models/domains';

export const domainsService = {
	fetch: async (): Promise<Domains.Model[]> => {
		const params = {
			filter: {
				status: Common.Status.PUBLISHED,
			},
			fields: ['*', 'to.url'],
		};

		try {
			const response = await $fetch<Domains.Model[]>(Domains.api, {
				method: 'POST',
				body: { params },
			});

			return response;
		} catch (error) {
			console.error('Failed to fetch Domains:', error);

			return [];
		}
	},
};
